<template>
  <div>
    <t-form ref="form" @submit.prevent>
      <ServiceRadioFormPart @result="onResult" @change="onChange" />
    </t-form>

    <FormErrorMessages :error-messages="errorMessages" />
  </div>
</template>

<script>
import AbstractFormStep from 'chimera/all/components/form/steps/AbstractFormStep'
import FormErrorMessages from 'chimera/all/components/form/FormErrorMessages'
import ServiceRadioFormPart from 'chimera/accountancy/components/form/parts/service/ServiceRadioFormPart'
import NextStep from '~/pages/offertes-aanvragen/je-gegevens'

export default {
  name: 'ServiceTypeFormStep',

  components: {
    ServiceRadioFormPart,
    FormErrorMessages,
  },

  extends: AbstractFormStep,

  /**
   * Pass through the submit event given from FormModal
   */
  created() {
    this.$nuxt.$on('submit', this.onSubmit)
  },

  /**
   * Clean up before component is destroyed
   */
  destroyed() {
    this.$nuxt.$off('submit')
  },

  methods: {
    /**
     * Transition
     */
    transition() {
      this.routeTo(NextStep)
    },
  },
}
</script>
